// extracted by mini-css-extract-plugin
export var actions = "_8-4";
export var brand = "_8-3";
export var header = "_8-0";
export var headerContent = "_8-1";
export var identity = "_8-5";
export var logo = "_8-2";